import http from '../../../utils/fetch';
export default {
    query(query) {
        return http({
            url: '/api/swyl/v1/viewagentlist/viewAgentList/selectPage',
            method: 'post',
            params: query
        });
    },
    check(query) {
        return http({
            url: '/api/swyl/v1/viewagentlist/viewAgentList/checkPage',
            method: 'post',
            params: query
        });
    },
    queryOne(id,isApprove) {
        return http({
            url: '/api/swyl/v1/viewagentlist/viewAgentList/selectById',
            method: 'post',
            params: {id,isApprove}
        });
    },
     queryOnesh(id,isApprove) {
        return http({
            url: '/api/swyl/v1/viewagentlist/viewAgentList/selectByIdsh',
            method: 'post',
            params: {id,isApprove}
        });
    },
    agentPassDaqu(query) {
        return http({
            url: '/api/swyl/v1/agent/bscUserInfoAgent/agentPassDaqu',
            method: 'post',
            data: query
        });
    },
    updateDaquPass(query) {
        return http({
            url: '/api/swyl/v1/agent/bscUserInfoAgent/updateDaquPass',
            method: 'post',
            data: query
        });
    },
    agentPass(query) {
        return http({
            url: '/api/swyl/v1/agent/bscUserInfoAgent/agentPass',
            method: 'post',
            data: query
        });
    },
    agentPassFenxiao(query) {
        return http({
            url: '/api/swyl/v1/agent/bscUserInfoAgent/agentPassFenxiao',
            method: 'post',
            data: query
        });
    },
    agentPass2(query) {
        return http({
            url: '/api/swyl/v1/agent/bscUserInfoAgent/agentPass2',
            method: 'post',
            data: query
        });
    },
    agentPass3(query) {
        return http({
            url: '/api/swyl/v1/agent/bscUserInfoAgent/agentPass3',
            method: 'post',
            data: query
        });
    },
    update(v) {
        return http({
            url: '/api/swyl/v1/basic/bscUserInfo/updateByUserCode',
            method: 'post',
            params: v
        });
    },
    updateById(v) {
        return http({
            url: '/api/bscUserInfoAgentBasic/updateById',
            method: 'post',
            params: v
        });
    },
    agentPassUpdate(v) {
        return http({
            url: '/api/swyl/v1/agent/bscUserInfoAgent/agentPassUpdate',
            method: 'post',
            data: v
        });
    },
    updateEndTime(v) {
        return http({
            url: '/api/swyl/v1/hetong/bscContract/updateByCode',
            method: 'post',
            params: v
        });
    },
    getFenxiaoByInstid(instid) {
        return http({
            url: '/api/swyl/v1/agent/bscUserInfoAgent/getFenxiaoByInstid?instid='+instid,
            method: 'post',
        });
    },
    queryLevel(customerGroup) {
        return http({
            url: '/api/swyl/v1/demo/bscUserInfoAgentLevel/queryLevel',
            method: 'post',
            params: {customerGroup}
        });
    },
    queryLevelZc(customerGroup) {
        return http({
            url: '/api/swyl/v1/demo/bscUserInfoAgentLevel/queryLevelZc',
            method: 'post',
            params: {customerGroup}
        });
    },
    queryLevelZcList(customerGroup) {
        return http({
            url: '/api/swyl/v1/demo/bscUserInfoAgentLevel/queryLevelZcList',
            method: 'post',
            params: {customerGroup}
        });
    },
    checkChangeLevelList(customerGroup) {
        return http({
            url: '/api/swyl/v1/demo/bscUserInfoAgentLevel/checkChangeLevelList',
            method: 'post',
            params: {customerGroup}
        });
    },
    queryLevelList(customerGroup) {
        return http({
            url: '/api/swyl/v1/demo/bscUserInfoAgentLevel/queryLevelList',
            method: 'post',
            params: {customerGroup}
        });
    },
    getNowTask(taskid) {
        return http({
            url: '/api/swyl/v1/agent/bscUserInfoAgent/getNowTask',
            method: 'post',
            params: {taskid}
        });
    },
    checkWhatChange(ywid) {
        return http({
            url: '/api/swyl/v1/agent/bscUserInfoAgent/checkWhatChange',
            method: 'post',
            params: {ywid}
        });
    },
    checkChange(ywid) {
        return http({
            url: '/api/swyl/v1/agent/bscUserInfoAgent/checkChange',
            method: 'post',
            params: {ywid}
        });
    },
    /*exportExcel(query) {
        return http({
            url: '/api/swyl/v1/viewagentlist/viewAgentList/downloadExcel',
            method: 'get',
            params: query
        });
    },*/
    updateShangWei(query) {
        return http({
            url: '/api/swyl/v1/agent/bscUserInfoAgent/agentUpdateShangWei',
            method: 'post',
            data: query
        });
    },
    expandShangWei(query) {
        return http({
            url: '/api/swyl/v1/agent/bscUserInfoAgent/expandShangWei',
            method: 'post',
            data: query
        });
    },

    updateCompanyService(query) {
        return http({
            url: '/api/swyl/v1/agent/bscUserInfoAgent/updateCompanyService',
            method: 'post',
            data: query
        });
    },
    updateAgentJbxn(query) {
        return http({
            url: '/api/swyl/v1/agent/bscUserInfoAgent/updateAgentJbxn',
            method: 'post',
            data: query
        });
    },

    selectMsgPage(query) {
        return http({
            url: '/api/swyl/v1/demo/bscUserInfoOperate/selectPage',
            method: 'post',
            params: query
        });
    },
    queryLq(query) { //�������б�,��Լ�ⶳ��ѯ
        return http({
            url: '/api/swyl/v1/demo/bscUserInfoLq/queryLq',
            method: 'post',
            params: query
        });
    },
    getLevelArea(query) { //�������б�,��Լ�ⶳ��ѯ
        return http({
            url: '/api/swyl/v1/demo/bscUserInfoLq/getLevelArea?usercode='+query,
            method: 'post',
        });
    },
    bscUserInfoLqUpdate(data,refid) { //�������б�,��Լ�ⶳ ����
        return http({
            url: '/api/swyl/v1/demo/bscUserInfoLq/update?refid='+refid,
            method: 'post',
            data: data
        });
    },
    updateByLianqun(data) {
        return http({
            url: '/api/swyl/v1/demo/bscUserInfoLq/updateByLianqun',
            method: 'post',
            data: data
        });
    },

    getOverseasAgent(userName) {
        return http({
            url: '/api/swyl/v1/agent/bscUserInfoAgent/getOverseasAgent?userName='+userName,
            method: 'post',
        });
    },
    agentThaw(data) {
        return http({
            url: '/api/bscUserInfoAgentBasic/agentThaw',
            method: 'post',
            params: data
        });
    },
    agentThawQY(data) {
        return http({
            url: '/api/bscUserInfoAgentBasic/agentThawQY',
            method: 'post',
            params: data
        });
    },
    agentOperate(data) {
        return http({
            url: '/api/bscUserInfoAgentBasic/agentOperate',
            method: 'post',
            params: data
        });
    },
    showCtMsg(usercode) {
        return http({
            url: '/api/bscUserInfoAgentBasic/showCtMsg?usercode='+usercode,
            method: 'post',
        });
    },
    selectFenxiaoListPage(query) {
        return http({
            url: '/api/bscUserInfoAgentBasic/selectFenxiaoListPage',
            method: 'post',
            params: query
        });
    },
    // 批量冻结
    freezebatchByIdFx(query){
        return http({
            url: '/api/bscUserInfoAgentBasic/freezebatchByIdFx',
            method: 'post',
            data: query
        });
    },
    // 批量解冻
    thawbatchByIdFx(query){
        return http({
            url: '/api/bscUserInfoAgentBasic/thawbatchByIdFx',
            method: 'post',
            data: query
        });
    },
    agentUpdateFile(data) {
        return http({
            url: '/api/bscUserInfoAgentUpdateFile/selectListPage',
            method: 'post',
            params: data
        });
    },
    thawOperate(query) {
        return http({
            url: '/api/bscUserInfoAgentBasic/thawOperate',
            method: 'post',
            params: query
        });
    },

    agentThawPass(query) {
        return http({
            url: '/api/bscUserInfoAgentBasic/agentThawPass',
            method: 'post',
            params: query
        });
    },
    agentThawDaquPass(query) {
        return http({
            url: '/api/bscUserInfoAgentBasic/agentThawDaquPass',
            method: 'post',
            params: query
        });
    },
    agentLqDaquPass(query) {
        return http({
            url: '/api/swyl/v1/demo/bscUserInfoLq/agentLqDaquPass',
            method: 'post',
            data: query
        });
    },
    agentLqPass(query) {
        return http({
            url: '/api/swyl/v1/demo/bscUserInfoLq/agentLqPass',
            method: 'post',
            data: query
        });
    },
    getThawLq(query) {
        return http({
            url: '/api/swyl/v1/demo/bscUserInfoLq/getThawLq',
            method: 'post',
            params: query
        });
    },
    getLqFile(query) {
        return http({
            url: '/api/swyl/v1/demo/bscUserInfoLq/getLqFile',
            method: 'post',
            params: query
        });
    },
    getLqSelectList(query) {
        return http({
            url: '/api/swyl/v1/demo/bscUserInfoAgentStandard/selectList',
            method: 'post',
            params: query
        });
    },
    getAgentByName(userName) {
        return http({
            url: '/api/swyl/v1/viewagentlist/viewAgentList/getAgentByName?userName='+userName,
            method: 'post',
        });
    },

}
